import React, { Component } from "react";

class About extends Component {
    render(){
        return(
            <div className = "content-wrapper">
            <p className="pageContent">hello, about </p>
            <div class="push"></div>
            </div>
        )
    }
}

export default About;